export default __webpack_public_path__ + "0a6fa42b0ee2cd8286ccb5c9a4c0e727.svg";